module.exports = "/static-assets/_next/static/images/tv-cutout-afaca1271bd3df107063d7d9fb06821f.png";